/**
 * Labstep
 *
 * @module components/ProtocolValue/Form/ShowEdit/ResourceTemplate
 * @desc ShowEdit for experiment value resource template
 */

import { ResourceInfoPreview } from 'labstep-web/components/Resource/Info/Preview';
import { FormShowEditSearchSelect } from 'labstep-web/core/Form/ShowEdit/SearchSelect';
import { Resource } from 'labstep-web/models/resource.model';
import type React from 'react';
import type { IProtocolValueFormShowEditResourceTemplateProps } from './types';

export const ProtocolValueFormShowEditResourceTemplate: React.FC<
  IProtocolValueFormShowEditResourceTemplateProps
> = ({ protocolValue, initialEditingState, ...rest }) => (
  <FormShowEditSearchSelect
    dataCy="components/ProtocolValue/Form/ShowEdit/ResourceTemplate"
    placeholder="Restrict to specific category"
    childEntityName={Resource.entityName}
    childKeyName="resource_template"
    parentEntity={protocolValue}
    optimistic={false} // This is because resource_template_id can become null
    searchSelectProps={{
      params: { is_template: true },
      creatable: true,
      createBody: { is_template: true },
      entityNameForText: Resource.templateEntityName,
    }}
    initialEditingState={initialEditingState}
  >
    {protocolValue.resource_template && (
      <ResourceInfoPreview
        resource={protocolValue.resource_template}
        {...rest}
      />
    )}
  </FormShowEditSearchSelect>
);
